import React from 'react';

function ReputationSkeleton() {
    return (
        <div className="reputation-skeleton">
            <div className="reputation-skeleton__stats">
                {Array.from({ length: 4 }).map((_, index) => (
                    <div key={`reputation-stat-skeleton-${index}`} className="reputation-skeleton__stat" />
                ))}
            </div>
            <div className="reputation-skeleton__panel" />
            <div className="reputation-skeleton__panel reputation-skeleton__panel--short" />
        </div>
    );
}

export default ReputationSkeleton;
